import React, { useState } from 'react'
import { DialogProfileContact } from './DialogProfileContact'
import { initialState } from './model'

export const Crear = () => {
    const [open, setOpen] = useState(false)

    return (
        <>
            <button className='btn p-btn-primary' onClick={() => setOpen(true)}>
                <i className="bi bi-plus"></i> Crear
            </button>

            {open && (
                <DialogProfileContact
                    open={open}
                    setOpen={setOpen}
                    initialState={initialState}
                />
            )}

        </>
    )

}
